import TokenLogo from '@/components/ui/token-logo'
import { Address, zeroAddress } from 'viem'

export const CurrencyLogo = ({
  chainId,
  address,
  width = 32,
  height = 32,
}: {
  chainId?: number
  address?: Address
  width?: number
  height?: number
}) => {
  if (address === zeroAddress) {
    return (
      <TokenLogo srcs={[`https://icons.zapify.dev/chains/hyperevm.svg`]} alt={'token'} width={width} height={height} />
    )
  }

  return (
    <TokenLogo
      srcs={[`https://token-list-2te.pages.dev/images/${chainId}/${address}.png`]}
      alt={'token'}
      width={width}
      height={height}
    />
  )
}
